import cloneDeep from 'lodash/cloneDeep';
import { NotificationModel } from '@ps20-frontend/gui-components';
import { DashboardAction, DashboardActions } from '../dashboard.actions';

export const notificationsReducer = function (
  sectionState: Array<NotificationModel> = null,
  action: DashboardAction<NotificationModel>,
): Array<NotificationModel> {
  switch (action.type) {
    case DashboardActions.ADD_NOTIFICATION: {
      const newState: Array<NotificationModel> = cloneDeep(sectionState);
      newState.push(action.payload);
      return newState;
    }
    case DashboardActions.DELETE_NOTIFICATION: {
      const newState: Array<NotificationModel> = cloneDeep(sectionState);
      newState.splice(0, 1);
      return newState;
    }
    default:
      return sectionState;
  }
};
